<template>
    <div>
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="container-notfound">
                       <p class="title-nf">4 <font-awesome-icon class="me-2" icon="fa-solid fa-triangle-exclamation"/>4</p>
                    </div>
                    <p class="text-nf inter-light-38">Esta página web no está disponible</p>
                    <p class="text-nf monserrat-medium-16">SIAHE - 2023 </p>
                    <p class="options"><a class="btn-primary-o" href="#" @click="handleCerrarSesion()">Cerrar Sesión</a></p>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.container-notfound{
margin-top:20vh;
}
.title-nf{
    font-size: 7rem;
    font-weight: bold;
    text-align: center;
    color:#691A30;
    letter-spacing: -0.3rem;
}
.text-nf{
    margin-top:-1rem;
    text-align: center;
}
.options{
    text-align: center;
}
.options a{
    text-decoration: none;
    padding: .5rem;
}
</style>
<script>
import mapHelper from '@/store/modules/common/map-helper';
  export default{
    data:function(){
        return{
        };
    },
    methods:{
      async handleCerrarSesion() {
      await this.$store.dispatch(
        mapHelper.mapmod.SIAHE_AUTH + mapHelper.mapfn.logOut
      );
      this.$router.push({ name: "Login" });
    },
    }
  }
</script>
